import { Paragraph, PriceBadge, Image } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';
import { PriceType } from '@app/shared/types/common';
import { useSettlementClickAction } from '@app/shared/hooks/useSettlementClickAction';
import { Settlement as SettlementType } from '@app/store/slices/settlements/settlementsTypes';
import { SettlementModalAction } from '@app/shared/types/pages/home';

interface SettlementCardProps {
  settlement: SettlementType;
  imageUrl?: string | null;
  withoutBackground?: boolean;
  onClick?: (settlement: SettlementType, action: SettlementModalAction) => void;
  className?: string;
}

const SettlementBackground = () => (
  <div className="absolute inset-0 m-auto mr-0 size-4/5 rounded-lg border-r-4 border-t-4 border-orange-500 bg-[#fee4c9] shadow-lg" />
);

const SettlementImage = ({ imageUrl, title }: { imageUrl: string; title?: string }) => (
  <Image
    src={imageUrl}
    className="relative z-10 aspect-square w-full rounded-lg object-contain"
    alt={title ? `${title} settlement` : 'Settlement'}
  />
);

const SettlementTitle = ({ title, isDisabled }: { title: string; isDisabled: boolean }) => (
  <div className={cn('ml-auto w-4/5 overflow-hidden grid mr-auto', isDisabled && 'grayscale')}>
    <Paragraph
      size="xs"
      style={{ gridColumn: 'none' }}
      className="w-fit max-w-full truncate rounded-lg border bg-[#fee4c9] px-2 text-center shadow"
      title={title}
      variant="secondary"
    >
      {title}
    </Paragraph>
  </div>
);

export function Settlement({
  settlement,
  imageUrl,
  withoutBackground = false,
  onClick,
  className,
}: SettlementCardProps) {
  const { onClickHandler } = useSettlementClickAction({ settlement, onSettlementClick: onClick });

  return (
    <div
      className={className}
      onClick={() => {
        if (onClick) {
          onClickHandler();
        }
      }}
    >
      <div className="relative">
        <div className={cn(!settlement.isPurchased && 'grayscale')}>
          {settlement.price && <PriceBadge type={PriceType.TON} price={settlement.price} />}
          {!withoutBackground && <SettlementBackground />}
          {imageUrl && <SettlementImage imageUrl={imageUrl} title={settlement.name} />}
        </div>
      </div>

      {settlement.name && (
        <SettlementTitle title={settlement.name} isDisabled={!settlement.isPurchased} />
      )}
    </div>
  );
}
